export enum LineTypeEnum {
  VIRTUAL = "VIRTUAL",
  REGULAR = "REGULAR",
  BRING_YOU_OWN = "BRING_YOU_OWN",
  PRE = "PRE"
}

export type SettingsPageLinePlan = {
  id: number;
  name: string;
};

export type SettingsPageLineCarrier = {
  id: number;
  name: string;
};

export type SettingsPageLineDistributionCenter = {
  id: number;
  name: string;
};

type SettingsPageContractItem = {
  id: number;
  name: string;
};

type SettingsPageLineInventory = {
  id: number;
  product: SettingsPageLineInventoryProduct;
  serialNumber?: string;
};

type SettingsPageLineInventoryProduct = {
  id: number;
  name: string;
};

export interface SettingsPageLine {
  id: number;
  number: string;
  lineStatus: LineStatus;
  carrierStatus: CarrierStatus;
  aquisitionDate: string;
  type: LineTypeEnum;
  isBringYourOwn: boolean;
  inventoryId?: number;
  contractItems?: Array<SettingsPageContractItem>;
  plans: Array<SettingsPageLinePlan>;
  inventory?: SettingsPageLineInventory;
  carrier?: SettingsPageLineCarrier;
  distributionCenters?: Array<SettingsPageLineDistributionCenter>;
}

export interface CreateLineForm {
  carrier: {
    id: number;
    name?: string;
  };
  carrierStatus: CarrierStatus;
  aquisitionDate: string;
  isBringYourOwn: boolean;
  lines: Array<string>;
  type: LineTypeEnum;
  lineStatus: LineStatus;
  distributionCenters?: Array<number>;
  plans: Array<number>;
}

export interface EditLineForm {
  plans: Array<number>;
  number: string;
  lineStatus: LineStatus;
  type: LineTypeEnum;
  inventorySerialNumber?: string;
  carrier: SettingsPageLineCarrier;
  carrierStatus: CarrierStatus;
  aquisitionDate: string;
  isBringYourOwn: boolean;
  restrictByDistributionCenter?: boolean;
  distributionCenters?: Array<number>;
}

export enum LineStatus {
  ACTIVE = "ACTIVE",
  RESERVED = "RESERVED",
  IN_USE = "IN_USE",
  SOLD = "SOLD",
  BACK_TO_CARRIER = "BACK_TO_CARRIER",
  REMOVED = "REMOVED"
}

export enum TranslatedLineStatus {
  ACTIVE = "Ativa",
  RESERVED = "Reservada",
  SOLD = "Vendida",
  IN_USE = "Em Uso",
  BACK_TO_CARRIER = "Devolvido para operadora",
  REMOVED = "Removido"
}

export enum CarrierStatus {
  ACTIVE = "ACTIVE",
  BLOCKED = "BLOCKED",
  SUSPENDED = "SUSPENDED",
  PROVISIONAL = "PROVISIONAL",
  MUREG = "MUREG"
}
